export interface SubmitRetroCreditRequest {
  restaurantId: number;
  checkNumber: string;
  transactionDate: string;
  transactionAmount: string;
  onlineOrderId?: string;
}

export interface SubmitRetroCreditError {
  message: string;
  category: string;
  correlationId: string;
  validationErrors: RetroCreditValidationError[];
}

export enum RetroCreditValidationErrorCode {
  ReachedDailyLimit = 'RC-2001',
  ReachedWeeklyLimit = 'RC-2006',
  ReachedMonthlyLimit = 'RC-2002',
  NotARewardsMember = 'RC-2003',
  DuplicateRequest = 'RC-1010',
}

export interface RetroCreditValidationError {
  message?: string;
  name?: string;
  errorCode: RetroCreditValidationErrorCode;
}

export class SubmitRetroCreditException extends Error {
  constructor(public errors: RetroCreditValidationError[]) {
    super();
  }
}
